import "./order-confirmation-page.style.scss";

import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, GridContainer, GridItem, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { IconCheckCircleFill } from "@amzn/stencil-react-icons";
import { PageMainContainer } from "@amzn/it-shop-shared-components";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { Paths, buildPath } from "../../common/paths/paths";
import { useSession } from "../../common/providers/session-provider";
import { PERMISSIONS } from "../../config";
import React from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";

interface ConfirmationLocationState {
  orderId: string;
  orderReference: string;
  itemType: string;
}

const OrderConfirmationPage: React.FC = () => {
  const history = useHistory();
  const { hasPermission } = useSession();
  const location = useLocation<ConfirmationLocationState | undefined>();
  const state = location.state;

  if (!state?.orderReference) {
    return <Redirect to={Paths.search.url} />;
  }

  const { orderId, orderReference } = state;
  const viewOrder = () =>
    hasPermission(PERMISSIONS.USE_LCR)
      ? history.push(buildPath(Paths.amznhamOrderTracking.url, { orderId }))
      : history.push({ pathname: Paths.orders.url, hash: orderId });

  return (
    <PageMainContainer paddingTop="100px">
      <GridContainer>
        <GridItem lg={2} />
        <GridItem lg={2}>
          <View display="flex" justifyContent="center" width="100%" height="100%">
            <div className="earth-icon" style={{ backgroundImage: "url('/img/earth.svg')" }} />
          </View>
        </GridItem>
        <GridItem lg={6}>
          <Col gridGap="S500">
            <Row gridGap="S300">
              <IconCheckCircleFill
                color="green70"
                aria-label={getString("orderConfirmation.success")}
              />
              <Text fontSize="T300" fontWeight="bold" data-testid="confirmation-title">
                {getString("orderConfirmation.confirmationTitle")}
              </Text>
            </Row>

            <Col gridGap="S300">
              <Text fontSize="T200" fontWeight="bold" data-testid="confirmation-order-id">
                {getString("orderConfirmation.orderId")}
                {orderReference}
              </Text>
              <Text fontSize="T200" data-testid="confirmation-description">
                {getString("orderConfirmation.confirmationDescription")}
              </Text>
            </Col>

            <Row gridGap="S300">
              <Button
                variant={ButtonVariant.Secondary}
                onClick={viewOrder}
                data-testid="view-order-button"
              >
                {getString("orderConfirmation.viewOrderButton")}
              </Button>
              <Button
                variant={ButtonVariant.Tertiary}
                onClick={() => history.push(Paths.search.url)}
                data-testid="return-home-button"
              >
                {getString("orderConfirmation.returnHomeButton")}
              </Button>
            </Row>
          </Col>
        </GridItem>
        <GridItem lg={2} />
      </GridContainer>
    </PageMainContainer>
  );
};

export default OrderConfirmationPage;
